import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import {ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
@Component({
  selector: 'app-microsoft-rejection-grid',
  templateUrl: './microsoft-rejection-grid.component.html',
  styleUrls: ['./microsoft-rejection-grid.component.scss']
})
export class MicrosoftRejectionGridComponent implements OnInit {
constructor(public appservice:AppService,public router:Router) { }
  verifyemployee(data:any){
    this.appservice.microsoftrejecteditdata=data;
this.router.navigate(['/home/microsoft-rejectionform']);
  }
  

  ngOnInit(): void {
    this.appservice.GetMicrosoft_Rejcet_details(); 
  }


}
